import React from 'react'
import clsx from 'clsx'
import {Typography} from '../components/Typography'
import {ImgFilters} from '../components/ImgFilters'

const Card = ({children}) => {
  return (
    <div className="space-y-5 mt-5 lg:max-w-xs">
      <div className="bg-white shadow-1">{children}</div>
    </div>
  )
}

Card.Image = ({src, height = 'h-32', className}) => {
  const style = clsx('relative w-full', height, className)
  return (
    <div className={style}>
      <ImgFilters img={src} />
    </div>
  )
}

Card.Content = ({children}) => {
  return <div className="p-4 space-y-2">{children}</div>
}

Card.Title = ({title, children}) => {
  return (
    <Typography
      weight="black"
      color="blue-500"
      size="lg"
      uppercase
      className="overflow-hidden h-14 truncate-2"
      title={title}
    >
      {children}
    </Typography>
  )
}

Card.Action = ({children}) => {
  return <div className="p-4 border-t border-gray-100">{children}</div>
}

export {Card}
